import { CommonConfig } from '../../../../configs/config.common';
import { AxiosPromise } from '../../../../utils/axios.promise';

// Not Injected, save Memory
export class CouponMyCouponsDelegate {

    private commonConfigs: CommonConfig = new CommonConfig();

    constructor() {
    }

    public async getList(partnerId: number, pageNum: number = 1, pageSize: number = 10): Promise<any> {
        const couponApi = this.commonConfigs.couponService;
        const fetched: any = AxiosPromise.get(`${couponApi}/coupon/instance/mycoupon?partnerId=${partnerId}&pageNum=${pageNum}&pageSize=${pageSize}`);
        if (fetched) {
            return fetched;
        } else {
            return null;
        }

    }

}
